import React from "react";
import {
  getFontFamily,
  getFontSize,
  getTextColor,
} from "../../../service/ui/UI";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import { Spinner } from "react-bootstrap";
import AppTranslation from "../../../service/app_translation/AppTranslation";

type Props = {
  name?: string;
  className?: string;
  textColor?: string;
  bgColor?: string;
  fontName?: string;
  fontSize?: string;
  paddingT?: number;
  paddingB?: number;
  width?: number;
  radius?: number;
  height?: number;
  handleClick?: (ev: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
  disabled?: boolean;
  processing?: boolean;

  title1?: string;
  title2?: string;
  handleClick1?: (ev: React.MouseEvent<HTMLButtonElement>) => void;
  handleClick2?: (ev: React.MouseEvent<HTMLButtonElement>) => void;
};

type PropsDouble = {
  name?: string;
  className?: string;
  textColor?: string;
  fontName?: string;
  fontSize?: string;
  paddingT?: number;
  paddingB?: number;
  width?: number;
  height?: number;

  title1: string;
  title2: string;
  handleClick1?: (ev: React.MouseEvent<HTMLButtonElement>) => void;
  handleClick2?: (ev: React.MouseEvent<HTMLButtonElement>) => void;

  isTab?: boolean;
  tabId?: "1" | "2";
};

const fontNameClass = (
  fontName: string,
  fontSize: string = "",
  textColor: string = ""
): string => {
  let classes: Array<string> = [];
  const fontNameClass = getFontFamily(
    UtilityHelper.isNotEmpty(fontName) ? fontName : "Bold"
  );
  const fontSizeClass = getFontSize(fontSize);
  const textColorClass = getTextColor(
    UtilityHelper.isNotEmpty(textColor) ? textColor : "theme-font"
  );

  if (UtilityHelper.isNotEmpty(fontNameClass)) {
    classes.push(fontNameClass);
  }
  if (UtilityHelper.isNotEmpty(fontSizeClass)) {
    classes.push(fontSizeClass);
  }
  if (UtilityHelper.isNotEmpty(textColorClass)) {
    classes.push(textColorClass);
  }

  return classes.join(" ");
};

export const ButtonSingle: React.FC<Props> = ({
  children,
  className = "",
  textColor = "",
  bgColor = "",
  handleClick,
  name = "",
  fontName = "",
  fontSize = "",
  width,
  height,
  radius,
  disabled = false,
  processing = false,
}) => {
  const classes: string = fontNameClass(fontName, fontSize, textColor);
  let style: any = {},
    classBgColor = " bgcolor-primary";

  if (width !== undefined) {
    style = { ...style, width: `${width}px` };
  }
  if (height !== undefined) {
    style = { ...style, height: `${height}px` };
  }
  if (radius !== undefined) {
    style = { ...style, borderRadius: `${radius}px` };
  }

  if (bgColor !== undefined || UtilityHelper.isNotEmpty(bgColor)) {
    classBgColor = `bgcolor-${bgColor}`;
  }

  return (
    <button
      id={name}
      name={name}
      type="button"
      className={`theme-btn ${classBgColor} processing ${
        width === undefined ? "w-100" : ""
      } ${classes} ${className}`}
      onClick={handleClick}
      style={style}
      disabled={processing ? true : disabled}
    >
      {children}
      {processing && <Spinner animation="border" role="status" size="sm" />}
    </button>
  );
};


export const ButtonDouble: React.FC<PropsDouble> = ({
    className = "",
    textColor = "",
    title1,
    title2,
    handleClick1,
    handleClick2,
    fontName = "",
    fontSize = "",
    width,
    height,
    isTab = false,
    tabId = "1",
  }) => {
    const classes: string = fontNameClass(fontName, fontSize, textColor);
    let styleHeight: any = {};
    let styleWidth: any = {};

    if (width !== undefined) {
      styleWidth = { ...styleWidth, width: `${width}px` };
    }
    if (height !== undefined) {
      styleHeight = { ...styleHeight, height: `${height}px` };
    }

    return (
      <div
        className={`double-buttons ${
          isTab ? "double-buttons-tab" : ""
        } ${classes} ${className}`}
        style={styleWidth}
      >
        <button
          type="button"
          className={`button-cancel theme-btn ${
            isTab
              ? tabId === "1"
                ? "bgcolor-primary"
                : "bgcolor-white color-primary"
              : "bgcolor-primary"
          } `}
          onClick={handleClick1}
          style={styleHeight}
        >
          {AppTranslation.text(title1)}
        </button>
        <button
          type="button"
          className={`button-confirm theme-btn ${
            isTab
              ? tabId === "2"
                ? "bgcolor-primary"
                : "bgcolor-white color-primary"
              : "bgcolor-primary"
          } `}
          onClick={handleClick2}
          style={styleHeight}
        >
          {AppTranslation.text(title2)}
        </button>
      </div>
    );
  };


/* 
export default class Button {
  static single: React.FC<Props> = ({
    children,
    className = "",
    textColor = "",
    bgColor = "",
    handleClick,
    name = "",
    fontName = "",
    fontSize = "",
    width,
    height,
    radius,
    disabled = false,
    processing = false,
  }) => {
    const classes: string = fontNameClass(fontName, fontSize, textColor);
    let style: any = {},
      classBgColor = " bgcolor-primary";

    if (width !== undefined) {
      style = { ...style, width: `${width}px` };
    }
    if (height !== undefined) {
      style = { ...style, height: `${height}px` };
    }
    if (radius !== undefined) {
      style = { ...style, borderRadius: `${radius}px` };
    }

    if (bgColor !== undefined || UtilityHelper.isNotEmpty(bgColor)) {
      classBgColor = `bgcolor-${bgColor}`;
    }

    return (
      <button
        id={name}
        name={name}
        type="button"
        className={`theme-btn ${classBgColor} processing ${
          width === undefined ? "w-100" : ""
        } ${classes} ${className}`}
        onClick={handleClick}
        style={style}
        disabled={processing ? true : disabled}
      >
        {children}
        {processing && <Spinner animation="border" role="status" size="sm" />}
      </button>
    );
  };

  static double: React.FC<PropsDouble> = ({
    className = "",
    textColor = "",
    title1,
    title2,
    handleClick1,
    handleClick2,
    fontName = "",
    fontSize = "",
    width,
    height,
    isTab = false,
    tabId = "1",
  }) => {
    const classes: string = fontNameClass(fontName, fontSize, textColor);
    let styleHeight: any = {};
    let styleWidth: any = {};

    if (width !== undefined) {
      styleWidth = { ...styleWidth, width: `${width}px` };
    }
    if (height !== undefined) {
      styleHeight = { ...styleHeight, height: `${height}px` };
    }

    return (
      <div
        className={`double-buttons ${
          isTab ? "double-buttons-tab" : ""
        } ${classes} ${className}`}
        style={styleWidth}
      >
        <button
          type="button"
          className={`button-cancel theme-btn ${
            isTab
              ? tabId === "1"
                ? "bgcolor-primary"
                : "bgcolor-white color-primary"
              : "bgcolor-primary"
          } `}
          onClick={handleClick1}
          style={styleHeight}
        >
          {AppTranslation.text(title1)}
        </button>
        <button
          type="button"
          className={`button-confirm theme-btn ${
            isTab
              ? tabId === "2"
                ? "bgcolor-primary"
                : "bgcolor-white color-primary"
              : "bgcolor-primary"
          } `}
          onClick={handleClick2}
          style={styleHeight}
        >
          {AppTranslation.text(title2)}
        </button>
      </div>
    );
  };
}
 */